import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Messaging } from "@teladoc/inbox";
import "@teladoc/inbox/dist/index.css";

import { prepareHttpHeaders } from "../utils/http";
import env from "../utils/env";

import "@teladoc/inbox/dist/index.css";

const Inbox = ({ appData }) => {
  const memberId = appData?.values?.logged_in_member_id || env("MEMBER_ID");
  const hostUrl = env("BASE_URL");
  const inboxConfig = env("INBOX_CONFIG");
  const headers = prepareHttpHeaders(null, false);

  useEffect(() => {
    const rootNode = document.getElementsByClassName("root-web-sdk")[0];

    if (!rootNode) return;

    const rootNodeClassList = rootNode.classList;

    rootNodeClassList.add("websdk-inbox");

    return () => rootNodeClassList.remove("websdk-inbox");
  }, []);

  const handleWebSDKAction = (action, fetchData) => {
    const replaceHistory = 0;

    appData.handleButtonClick(_, _, action, replaceHistory, _, _, fetchData);
  };

  return (
    <Messaging
      participantType='Member'
      participantId={memberId}
      withCredentials={false}
      hostUrl={hostUrl}
      headers={headers}
      withWebSdk
      handleWebSDKAction={handleWebSDKAction}
      {...inboxConfig}
    />
  );
};

Inbox.propTypes = {
  inboxConfig: PropTypes.objectOf(PropTypes.any),
  appData: PropTypes.objectOf(PropTypes.any)
};

export default Inbox;
